export default "__VITE_ASSET__CrbZ6sJ0__"